import classNames from 'classnames'
import React, { FC, ReactNode } from 'react'

import s from './WixMobileContentWrapper.scss'

type WixMobileContentWrapperProps = {
  className?: string
  children?: ReactNode
}

export const WixMobileContentWrapper: FC<WixMobileContentWrapperProps> = ({ children, className }) => {
  return <div className={classNames(s.wrapper, className)}>{children}</div>
}
